import React from 'react'
import { graphql, useStaticQuery } from 'gatsby'

import { FEATURES, hasFeatureFlag } from '@cinch/oxd-utils/feature-flags/src'

import SEO, { Breadcrumb } from '../components/seo'
import { getEnv, Env } from '@cinch/oxd-utils/env/src'

import Layout from '@cinch/oxd-layouts/regular/src'
import PageTitle from '@cinch/oxd-components/page-title/src/page-title.component'
import RichText from '@cinch/oxd-components/rich-text/src/rich-text.component'
import CovidInformationPage from '@cinch/oxd-pages/cambridge/covid-information/covid-information.component'

const InformationPage: React.FC<Cinch.SitePage> = ({ location }) => {
  const data: any = useStaticQuery(graphql`
    query InformationPageQuery {
      allTranslations {
        edges {
          node {
            covidInformation {
              heroTitle
              heroBody
              title
              contentBlocks {
                title
                body
                icon
              }
            }
          }
        }
      }
      largeHeroImage: file(relativePath: { eq: "covid-backpack.png" }) {
        childImageSharp {
          fluid(maxWidth: 1200, quality: 80) {
            src
            ...GatsbyImageSharpFluid_withWebp_noBase64
          }
        }
      }
      smallHeroImage: file(relativePath: { eq: "covid-backpack.png" }) {
        childImageSharp {
          fluid(maxWidth: 1200, quality: 80) {
            src
            ...GatsbyImageSharpFluid_withWebp_noBase64
          }
        }
      }
    }
  `)

  const i18n = data.allTranslations.edges[0].node.covidInformation

  const breadcrumbs: Breadcrumb[] = []

  if (location) {
    const pageUrl = `${getEnv(Env.SiteUrl)}${location.pathname}`
    breadcrumbs.push({
      item: pageUrl,
      name: i18n.title,
    })
  }

  let page = null

  if (hasFeatureFlag(FEATURES.CAMBRIDGE)) {
    const heroImage = {
      large: {
        webp: data.largeHeroImage.childImageSharp.fluid.srcWebp,
        png: data.largeHeroImage.childImageSharp.fluid.src,
      },
      small: {
        webp: data.smallHeroImage.childImageSharp.fluid.srcWebp,
        png: data.smallHeroImage.childImageSharp.fluid.src,
      },
      alt: i18n.heroImageAlt,
    }

    page = <CovidInformationPage i18n={i18n} heroImage={heroImage} />
  } else {
    page = (
      <Layout>
        <PageTitle>Helping you buy safely during COVID-19</PageTitle>
        <RichText>
          <p>
            As people are spending more time safe in their own homes, our website has been busy, with lots of customers
            browsing for their next car. We also understand some people may find they need a car to help them during
            these tricky times.
          </p>
          <p>
            We want to assure everyone that we’re closely following UK Government & Public Health guidance in response
            to COVID-19.{' '}
          </p>
          <p>
            Our car dealer partners are safely and surely welcoming you back to their retail locations introducing
            changes to protect both customers and their staff.
          </p>
          <p>
            If you have any questions about buying or selling a car safely at this time, please contact the cinch
            customer service team through live chat, text or WhatsApp.
          </p>
          <p>In the meantime, we hope you stay safe and healthy during this time.</p>
        </RichText>
      </Layout>
    )
  }

  return (
    <>
      <SEO title={i18n.c19Heading} desc={i18n.description} breadcrumbs={breadcrumbs} />
      {page}
    </>
  )
}

export default InformationPage
